import React, { PropsWithChildren } from 'react';
import { Modal } from '@placer-ui/components';
import styles from './location-modal-content.module.scss';
import classNames from 'classnames';
import { SupportRequestType } from 'features/offline-reports/support-requests/components/support-requests-modals/types';

export const SupportRequestModalContent = ({
    children,
    testId,
    requestModalType,
    avoidPadding,
    fullSize,
}: PropsWithChildren<{
    testId: string;
    requestModalType?: SupportRequestType;
    avoidPadding?: boolean;
    fullSize?: boolean;
}>) => {
    const isRequestTypeSelection = requestModalType === 'typeSelection';

    return (
        <Modal.Content fullSize={fullSize}>
            <div
                className={classNames(styles.locationModalContent, {
                    [styles.cardsContent]: isRequestTypeSelection,
                    [styles.noPaddingRight]: avoidPadding,
                    [styles.fullHeight]: fullSize,
                })}
                data-testid={testId}
            >
                {children}
            </div>
        </Modal.Content>
    );
};
